import React from 'react';
import * as b from "../bootstrap.module.css";
import LocalfirmContents from './content-column/localfirm-contents';
import LocalfirmProducts from './product-column/localfirm-products';
import Icon from "../icon.tsx";

const LocalfirmsNavigation = ({ activeNavigation, changeNavigation }) => {
  const previousStep = () => changeNavigation('');

  return (
    <div className={['top-navigation-tabs', 'active', activeNavigation !== 'localfirms_5' ? b.dNone : ''].join(' ')}>
      <div className="top-navigation-links">
        <button onClick={previousStep} className={["top-navigation-prev-step", b.dLgNone].join(' ')}>
          <span className={[b.container, b.dFlex, b.alignItemsCenter].join(' ')}>
            <span className={b.pr1}>
              <Icon icon="Angle-left" size={24} color="#2B2B2B" />
            </span>

            <span>
              Cofnij do
              <strong>menu głównego</strong>
            </span>
          </span>
        </button>

        <strong className={["top-navigation-title", b.mtLg0].join(' ')}>Pośrednicy kredytowi</strong>
        <p className={[b.mt2, b.pt1].join(' ')}>Co może zaoferować nam pośrednik kredytowy? Czy warto skorzystać z jego usług? Jak wybrać dobrego pośrednika, a czego unikać? Wszystko co musisz wiedzieć o pośrednikach kredytowych.</p>
      </div>
      
      <div className="top-navigation-products">
        <LocalfirmProducts active={activeNavigation === 'localfirms_5'} />
      </div>
      
      <div className="top-navigation-contents">
        <LocalfirmContents active={activeNavigation === 'localfirms_5'} />
      </div>
    </div>
  );
};

export default LocalfirmsNavigation;